import canUseDom from 'rc-util/lib/Dom/canUseDom';
import * as React from 'react';
import Notification from '../notification';
// Alpha version warning, should remove when published
if (process.env.NODE_ENV !== 'production' && canUseDom()) {
    const icon = (React.createElement("img", { alt: "antd", style: {
            filter: ' brightness(100)',
            width: 40,
            transform: 'translateX(-10px)',
        }, src: "https://gw.alipayobjects.com/zos/rmsportal/KDpgvguMpGfqaHPjicRK.svg" }));
    Notification.open({
        duration: 0,
        placement: 'top',
        message: React.createElement("span", { style: { color: '#FFF' } }, "You are using dev version"),
        description: (React.createElement("div", null,
            React.createElement("p", null, "Which is used for validating and may not same as final release version."),
            React.createElement("p", null, "DO NOT USE IN YOUR PRODUCTION!"),
            React.createElement("p", { style: { marginTop: 8 } },
                "Ref:",
                React.createElement("a", { target: "_blank", rel: "noreferrer", style: { marginInline: 4, color: '#FFF', textDecoration: 'underline' }, href: "https://github.com/ant-design/ant-design/issues/33862#user-content-alpha-offset" }, "#33862 - What is in experimental?")))),
        icon,
        closeIcon: React.createElement("span", { style: { color: '#FFF' } }, "X"),
        style: {
            background: '#CE5345',
            color: '#FFF',
        },
    });
}
